import { useEffect, useRef } from 'react'

export type UseCreateApiAbortSignal = () => AbortSignal

/**
 * Get created abort controller for the axios api request
 */
export function useCreateApiAbortSignal(): UseCreateApiAbortSignal {
  const controllerRef = useRef<AbortController | null>(null)
  useEffect(() => {
    return () => {
      controllerRef.current?.abort()
    }
  }, [])

  return () => {
    controllerRef.current?.abort()
    controllerRef.current = new AbortController()

    return controllerRef.current.signal
  }
}
